<div class="notification-box onhover-click" (click)="isNotifications = ! isNotifications">
  <app-common-svg-icons [icons]="'notification'"></app-common-svg-icons>
    <span class="badge rounded-pill badge-success">3 </span>
</div>
<div class="onhover-show-div notification-dropdown" [class.active]="isNotifications">
  <h6 class="f-18 mb-0 dropdown-title">Notification</h6>
  <ul>
    <li class="d-flex">
      <div class="notification-image">
        <img class="img-fluid" src="assets/images/avtar/3.jpg" alt="user" />
        <div class="notification-icon bg-danger">
          <i class="fa fa-heart"></i>
        </div>
      </div>
      <div>
        <p><span class="f-w-500 me-1">Emay Walter </span>liked your post</p>
        <span class="f-light">10 minutes ago</span>
      </div>
    </li>
    <li class="d-flex">
      <div class="notification-image">
        <img class="img-fluid" src="assets/images/avtar/4.jpg" alt="user" />
        <div class="notification-icon bg-info">
          <i class="fa fa-share-alt"></i>
        </div>
      </div>
      <div>
        <p><span class="f-w-500 me-1">Allie Grater</span>shared your post</p>
        <span class="f-light">5 hours ago</span>
      </div>
    </li>
    <li class="d-flex">
      <div class="notification-image">
        <img class="img-fluid" src="assets/images/avtar/7.jpg" alt="user" />
        <div class="notification-icon bg-success">
          <i class="fa fa-wechat"></i>
        </div>
      </div>
      <div>
        <p><span class="f-w-500 me-1">Colin Sik</span>commented on your post</p>
        <span class="f-light">yesterday</span>
      </div>
    </li>
    <li><a class="f-w-700" href="javascript:void(0)">Check all</a></li>
  </ul>
</div>
